module.exports = __webpack_public_path__ + "img/no-signal.b5f7e3d0.svg";